import $ from 'jquery';
import { StatusMsg } from './status';

export const validRoutes = ["","login","information","home","setting","passwordconfirm"];
export const Screen = {
    AUTH: 0,
    LOGIN: 1,
    SETTING: 2,
    HOME: 3,
    INFORMATION: 4,
    PASSWORD_CONFIRM: 5,
    ERROR_404: -1
}

export const formatMoney = (number, places, symbol, thousand, decimal) => {
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  symbol = symbol !== undefined ? symbol : '$';
  thousand = thousand || '.';
  decimal = decimal || ',';
  const negative = number < 0 ? '-' : '';
  const i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '';
  let j;
  j = (j = i.length) > 3 ? j % 3 : 0;
  return negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '') + symbol;
};

export const validateSettingAccessibility = (data) => {
    if (data?.apps?.length > 1 || data?.branches?.length > 1 || data?.branches[0]?.stores?.length > 1 || data?.branches[0]?.stores[0]?.cashiers?.length > 1)
        return true
    return false
}

// export const convertTransToCSV = (trans, customTableKeys, customDataKeys)  => {  
//         let result, ctr, columnDelimiter, lineDelimiter;

//         if (trans.length <= 0 || !trans) {
//             return null;
//         }

//         columnDelimiter = '","';
//         lineDelimiter = '"\r\n"';

//         let tableKeys = customTableKeys ? customTableKeys : Object.keys(trans[0]);
//         let dataKeys = customDataKeys ? customDataKeys : Object.keys(trans[0]);

//         result = '"';
//         result += tableKeys.join(columnDelimiter);
//         result += lineDelimiter;

//         trans.forEach(function (item,index) {
//             ctr = 0;
//             result += (index+1);
//             result += columnDelimiter;

//             dataKeys.forEach(function (key) {
//                 if (ctr > 0) result += columnDelimiter;
//                 if (key === "status"){
//                     result += StatusMsg[item[key]];
//                 } else {
//                     result += item[key];
//                 }
//                 ctr++;
//             });

//             if (index+1 < trans.length) {
//                 result += lineDelimiter;
//             }
//         });

//         return result;
// }

// export const exportCSV = (array, convertFunc) => (customTableKeys, customDataKeys) => {
//   console.log({array});
//     let data;
//     let filename, link;
//     let csv = convertFunc(array,customTableKeys, customDataKeys);
//     if (csv === null) return;

//     filename = 'export.xlsx';

//     if (!csv.match(/^data:text\/csv/i)) {
//         csv = 'data:text/csv;charset=utf-8,' + csv;
//     }
//     data = encodeURI(csv);
//     console.log({data});
//     link = document.createElement('a');
//     link.setAttribute('href', data);
//     link.setAttribute('download', filename);
//     link.click();
// }

$.ajaxSetup({ xhrFields: { withCredentials: true }, crossDomain: true });
